import React, { useState } from "react";
import PropTypes from "prop-types";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { Dropdown } from "@toddle-edu/ds-web";
import { CaretDownFilled, CaretUpFilled } from "@toddle-edu/ds-icons";
import { onEnterOrSpaceKeyDown } from "Utils";

import classes from "./CustomLoginBoxButton.scss";

const CustomLoginBoxButton = props => {
  const {
    iconUrl,
    buttonText,
    onClick,
    icon,
    iconContainerStyle,
    isDropDown,
    overlay,
  } = props;

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  return (
    <ConditionalWrapper
      type="wrapperAsElement"
      wrapper={<Dropdown overlay={overlay} />}
      condition={isDropDown}
      onVisibleChange={setIsDropdownVisible}
    >
      <div
        className={classes.container}
        data-test-id={props["data-test-id"]}
        onClick={!isDropDown ? onClick : () => {}}
        onKeyDown={e =>
          onEnterOrSpaceKeyDown(e, () => {
            if (!isDropDown && onClick) onClick(e);
          })
        }
        role="button"
        tabIndex={0}
        aria-label={buttonText}
      >
        {iconUrl && <img src={iconUrl} alt="" />}
        {!!icon && (
          <div className={classes.iconContainer} style={iconContainerStyle}>
            {icon}
          </div>
        )}
        <div className={classes.buttonTextContainer}>
          <div className={classes.buttonText}>{buttonText}</div>
          {isDropDown ? (
            <div className={classes.buttonTextIconContainer}>
              {isDropdownVisible ? <CaretUpFilled /> : <CaretDownFilled />}
            </div>
          ) : null}
        </div>
      </div>
    </ConditionalWrapper>
  );
};

CustomLoginBoxButton.defaultProps = {
  ["data-test-id"]: "button-custom-login-box-button",
};

CustomLoginBoxButton.propTypes = {
  iconUrl: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};

export default CustomLoginBoxButton;
